import React from 'react';
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data }) => {
    const cards = JSON.parse(data?.cards[0].value_data) ?? {};

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard
                        title="Total de despachos"
                        value={cards?.total ?? 0}
                    />

                    <ReportCard
                        title="Incompletos"
                        value={cards?.incomplete ?? 0}
                    />

                    <ReportCard
                        title="Completos (%)"
                        value={cards?.complete ?? 0}
                    />
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;